import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledServiceProvidingLocationCell = styled.div`
   display: grid;
   grid-template-columns: 1fr 24px;
   grid-template-rows: 1fr;
   grid-column-gap: 4px;
   align-items: center;
   width: 100%;
   height: 100%;
`;
StyledServiceProvidingLocationCell.displayName = 'StyledServiceProvidingLocationCell';

export const StyledServiceProvidingLocationCellContent = styled(StyledFlex)`
   overflow: hidden;
   height: 100%;
   justify-content: center;

   > * {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
   }
`;
StyledServiceProvidingLocationCellContent.displayName = 'StyledServiceProvidingLocationCellContent';
